<template>
	<div class="container">
		<b-overlay
			:show="loading"
			rounded="sm"
		>
			<h1 class="border-bottom d-flex mb-5">
				<span class="mr-auto">{{ header }}</span>
				<button
					class="btn btn-link"
					@click="openRaw"
				>
					<b-icon icon="eye"></b-icon>
				</button>
			</h1>
                        <h3>
                                        in
					<router-link
						:to='"/measurement/"+measurement_id'
					>{{measurement_id}}</router-link>
                        </h3>
			<div class="row">
			<!--	<div class="col-md-6">
					<FieldGroupCard
						:edit="edit"
						:fields="BREED_BASE_FIELDS_FLAT"
						:record="record"
						title="Breed base details"
						@change="onChange"
					/>
				</div>-->
				<div class="col-md-6" >
					<FieldGroupCard
						:fields="header_fields"
						:record="record"
						title="Header"
					/>
				</div>
				<div class="col-md-6">
					<FieldGroupCard
						:fields="data_fields"
						:record="data_short"
						title="Data snippet (first lines)"
					/>
				</div>
				<div class="col-md-6">
					<FieldGroupCard
						:fields="AUDIT_UNMODIFIABLE_FLAT"
						:record="record"
						title="Audit"
					/>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import apiClient from '@/apiClient'
import FieldGroupCard from '@/components/FieldGroupCard'
import { BREED_FIELDS_FLAT, BREED_BASE_FIELDS_FLAT, BREED_DOG_FIELDS_FLAT } from '@/fields/breed_fields'
import { AUDIT_UNMODIFIABLE_FLAT } from '@/fields/audit_fields'
import { readFieldFlat } from '@/util'

export default {
	components: { FieldGroupCard },
	data() {
		return {
			BREED_FIELDS_FLAT,
			BREED_BASE_FIELDS_FLAT,
			BREED_DOG_FIELDS_FLAT,
			AUDIT_UNMODIFIABLE_FLAT,
			loading: false,
			record: {},
			data_short: {}
		}
	},
	computed: {
		header() {
			const { _id } = this.record
			return _id
		},
                measurement_id() {
                    return this.$route.params.measurement_id
                },
		header_fields() {
		    var fields = Object.keys(this.record.header).map((k) => {return {field:`header.${k}`, label: k}})
		    return fields.sort((t1, t2) =>
		    t1.field.localeCompare(t2.field))
		},
		data_fields() {
		    var fields = Object.keys(this.record.data).map((k) => {return {field:k, label: k}})
		    return fields.sort((t1, t2) =>
		    t1.field.localeCompare(t2.field))
		},
	},
	methods: {
		readFieldFlat,
		async fetchRecord() {
			this.loading = true
			this.record = await apiClient.batchGet(
				this.$route.params.measurement_id,
				this.$route.params.mongo_batch_id,
			)
			for (const [key, value] of Object.entries(this.record.data)) {
			    this.data_short[key] = value[0]
			}
			this.loading = false
		},
		openRaw() {

			var tab = window.open('about:blank', '_blank');

			tab.document.write(JSON.stringify(this.record, null, 4));
			tab.document.close();
		},
	},
	watch: {
		$route(to, from) {
			this.fetchRecord()
		},
	},
	mounted() {
		this.fetchRecord()
	},
}
</script>
